<template>
    <popup-modal position="center" @close="$emit('close')">
        <div class="w-904 p-16">
            <div class="grid grid-cols-5 gap-16">
                <div class="col-span-3">
                    <p class="text-body font-semibold">{{ $t(`jobs.sharing.google-for-jobs.title`) }}</p>
                    <p v-html="$t(`jobs.sharing.google-for-jobs.message`)"></p>
                </div>
                <div class="col-span-2 rounded py-32" :style="{ backgroundColor: '#F5F5F8' }">
                    <div
                        class="w-full h-full bg-no-repeat bg-center"
                        :style="{ backgroundImage: 'url(' + card.image_url + ')', backgroundSize: '100%' }"
                    ></div>
                </div>
            </div>

            <div class="border-t my-40"></div>

            <h2 class="font-semibold text-body text-black mb-18">
                {{ $t(`jobs.sharing.google-for-jobs.vacancy_information`) }}
            </h2>

            <loading v-if="fetchingAvailableParameters"/>
            <template v-else>
                <job-location-editor v-model="form" class="space-y-8 mb-24"/>
                <job-meta-data-editor v-model="form"/>
            </template>

            <simple-button
                class="ml-auto mt-24"
                display="secondary"
                icon="save"
                :loading="saving"
                look="primary"
                @click="save"
            >
                {{ $t('general.save') }}
            </simple-button>
        </div>
    </popup-modal>
</template>
<script>
import PopupModal from "./ui/PopupModal";
import Loading from "./ui/Loading";
import SimpleButton from "./ui/SimpleButton";
import Job from "../models/Job";
import JobLocationEditor from "./JobLocationEditor";
import Form from "../etc/forms/Form";
import * as jobs from "../services/JobService";
import {normalizeJson} from "../../shared/helpers";
import JobMetaDataEditor from "./JobMetaDataEditor";
import Domain from "../models/Domain";
import ShareJobCard from "../models/ShareJobCard";
import {mapStores} from "pinia";
import {useJobsStore} from "../state/modules/jobs";
import {useRepo} from "pinia-orm";

export default {
    components: {
        JobMetaDataEditor,
        JobLocationEditor, SimpleButton, Loading, PopupModal},
    props: {
        card: ShareJobCard,
        job: Job
    },
    data() {
        return {
            form: new Form([
                { name: 'company_location_id', value: this.job.company_location_id },
                { name: 'postal_code', value: this.job.postal_code },
                { name: 'city', value: this.job.city },
                { name: 'country', value: this.job.country, rules: ['required'] },
                { name: 'remote', value: this.job.remote},
                { name: 'og_title', value: this.job.og_title, rules: ['required'], translatable: true},
                { name: 'og_description', value: this.job.og_description, rules: ['required'], translatable: true},
            ]),
            saving: false
        }
    },
    computed: {
        ...mapStores(useJobsStore),
        fetchingAvailableParameters() {
            return this.jobsModuleStore.fetchingAvailableParameters;
        }
    },
    methods: {
        save() {
            this.saving = true;

            this.form
                .submit(data => {
                    if (!data.company_location_id)
                        data.company_location_id = null;

                    return jobs.update(this.job.id, {
                        data: {attributes: data},
                    });
                })
                .then(result => jobs.find(result.id))
                .then(result => {
                    return useRepo(Job).save(normalizeJson(result));
                })
                .then(() => {
                    this.saving = false;
                    this.$emit('close');
                });
        }
    },
    mounted() {
        this.jobsModuleStore.SET_FETCHING_AVAILABLE_PARAMETERS(true);

        jobs.parameters().then(result => {
            useRepo(Domain).save(normalizeJson(result.data.domain));
            this.jobsModuleStore.setAvailableParameters(result.data);
            this.jobsModuleStore.SET_FETCHING_AVAILABLE_PARAMETERS(false);
        });
    }
}
</script>
